/* eslint-disable no-console */
import { requestSuccess } from "@Api";
import { DISPLAY_NOTIFICATION, DISMISS_NOTIFICATION } from "@Actions/types";

// Libraries
import { Store as notificationStore } from "react-notifications-component";
import { Sound, Logo } from "@Assets";

if ("Notification" in window) {
	Notification.requestPermission().then((permission) => {
		console.log("Permission:", permission);
	});
}

const notificationSound = new Audio(Sound);

export const showBrowserNotification = async () => {
	try {
		if (Notification.permission !== "granted") return;
		notificationSound.currentTime = 0;
		notificationSound.play().catch(() => {
			console.log("Safari blocked autoplay sound. Try after user interaction.");
		});

		const notification = new Notification(`Max Monitor`, {
			body: `Tiene un nuevo mensaje.`,
			icon: Logo,
			tag: "message",
			renotify: true,
			requireInteraction: false,
			silent: true,
		});

		notification.onclick = () => {
			window.focus();
			notification.close();
		};
	} catch (e) {
		console.log(e);
	}
};

export const displayNotification = ({ text, isError = false, isTemporary = false }) => {
	return (dispatch) => {
		if (isTemporary) {
			notificationStore.addNotification({
				type: isError ? "danger" : "success",
				title: isError ? "Error" : "Exito",
				message: text,
				insert: "top",
				container: "top-right",
				animationIn: ["animate__animated animate__fadeInRight"],
				animationOut: ["animate__animated animate__fadeOutRight"],
				dismiss: {
					duration: 5000,
					onScreen: true,
					pauseOnHover: true,
				},
			});
		} else {
			dispatch(requestSuccess(DISPLAY_NOTIFICATION, { text, isError }));
		}
	};
};

export const dismissNotification = () => {
	return (dispatch) => {
		dispatch(requestSuccess(DISMISS_NOTIFICATION));
	};
};
